'use strict'

import React, { memo } from 'react'

const Summary = () => {
  return (
    <section className='row my-5 py-1'>
      <div className='col'>
        <q cite='https://en.wikipedia.org/wiki/Universally_unique_identifier'>
          A universally unique identifier&nbsp; (UUID) is a 128-bit number used
          to identify information&nbsp; in computer systems. The probability to
          find a duplicate&nbsp; within 103 trillion version-4 UUIDs is one
          in&nbsp; a billion.
        </q>
        &nbsp;
        <a
          href='https://en.wikipedia.org/wiki/Universally_unique_identifier'
          target='blank'
        >
          Wikipedia
        </a>
      </div>
    </section>
  )
}

export default memo(Summary)
